export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13869.e5376b9f.jpg";